import { Respuesta, RespuestaExtra } from "../../../layout/investigaciones/ver-respuestas/Respuesta";
import { RespuestaEncuesta, RespuestaUsuario } from "@DTOS";

export abstract class ProcesoDatos {
    respuestasEnCrudo: RespuestaUsuario[];
    rangosEdad: Respuesta[];
    generos: Respuesta[];
    paises: Respuesta[];
    regiones: Respuesta[];
    ciudades: Respuesta[];
    respuestasProcesadas: Map<number, RespuestaExtra>;

    abstract cargarDatos(): void;
    abstract procesar(respuestasEncuesta: RespuestaEncuesta[]): void;
    abstract procesarDesde(respuestasUsuario: RespuestaUsuario[]): void;
}
